import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';
import { WithdrawEntityService } from '@views/pages/apps/general/withdrawals/services/withdraw-entity.service';


@Injectable()
export class WithdrawResolver implements Resolve<boolean> {

    constructor(private withdrawService: WithdrawEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.withdrawService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.withdrawService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }

}
